module.exports = __webpack_public_path__ + "media/images/ohap_courses_on-e3eca565f3a2aa0721d1002a270eabb1.png";